import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';

import {NalazComponent} from './nalaz.component.js';
import {GridComponent} from './grid/grid.js';
import FormComponent from './form/form.js';

const nalaz = angular.module('nalaz', [uiModal]);

nalaz.component('nalaz', NalazComponent);
nalaz.component('nalazForm', FormComponent);
nalaz.component('nalazGrid', GridComponent);

export {nalaz};



// WEBPACK FOOTER //
// ./app/components/nalaz/nalaz.js